/** Raw material warehouse & Finished goods storage — order matches design spec. */
export const STORAGE_WAREHOUSE_UNIT_OPTIONS = [
  { value: 'sq_ft', label: 'Sq.ft' },
  { value: 'sq_m', label: 'Sq.m' },
  { value: 'mt', label: 'MT' },
  { value: 'kl', label: 'KL' },
];

/** Cold storage — order matches design spec. */
export const COLD_STORAGE_UNIT_OPTIONS = [
  { value: 'mt', label: 'MT' },
  { value: 'kl', label: 'KL' },
  { value: 'cu_m', label: 'Cu.m' },
];

const warehouseLabelMap = Object.fromEntries(
  STORAGE_WAREHOUSE_UNIT_OPTIONS.map((o) => [o.value, o.label]),
);
const coldLabelMap = Object.fromEntries(
  COLD_STORAGE_UNIT_OPTIONS.map((o) => [o.value, o.label]),
);

const WAREHOUSE_UNIT_ALIASES = {
  sqft: 'sq_ft',
  square_feet: 'sq_ft',
  sqm: 'sq_m',
  square_meters: 'sq_m',
  square_meter: 'sq_m',
  metric_ton: 'mt',
  kiloliter: 'kl',
  kiloliters: 'kl',
};

const COLD_UNIT_ALIASES = {
  metric_ton: 'mt',
  kiloliter: 'kl',
  kiloliters: 'kl',
  cum: 'cu_m',
  cubic_meter: 'cu_m',
  cubic_meters: 'cu_m',
};

const resolveFromOptions = (unit, options, aliases, fallback) => {
  if (unit == null || unit === '') return fallback;
  const raw = String(unit).trim();
  const token = raw.toLowerCase().replace(/\./g, '').replace(/\s+/g, '_');
  if (options.some((o) => o.value === token)) return token;
  if (aliases[token]) return aliases[token];
  const byLabel = options.find((o) => o.label.toLowerCase() === raw.toLowerCase());
  if (byLabel) return byLabel.value;
  return token;
};

export const resolveStorageWarehouseUnit = (unit) =>
  resolveFromOptions(unit, STORAGE_WAREHOUSE_UNIT_OPTIONS, WAREHOUSE_UNIT_ALIASES, 'sq_ft');

export const resolveColdStorageUnit = (unit) =>
  resolveFromOptions(unit, COLD_STORAGE_UNIT_OPTIONS, COLD_UNIT_ALIASES, 'mt');

export const storageWarehouseUnitLabel = (unit) =>
  warehouseLabelMap[resolveStorageWarehouseUnit(unit)] || String(unit || 'Sq.ft');

export const coldStorageUnitLabel = (unit) =>
  coldLabelMap[resolveColdStorageUnit(unit)] || String(unit || 'MT');

/** Normalize storage capacity units on load/save. */
export const normalizeStorageFacilityFields = (fd) => {
  if (!fd || typeof fd !== 'object') return fd;
  const out = { ...fd };
  if (out.rawMaterialWarehouseUnit != null || out.raw_material_warehouse_unit != null) {
    out.rawMaterialWarehouseUnit = resolveStorageWarehouseUnit(
      out.rawMaterialWarehouseUnit ?? out.raw_material_warehouse_unit,
    );
  }
  if (out.finishedGoodsStorageUnit != null || out.finished_goods_storage_unit != null) {
    out.finishedGoodsStorageUnit = resolveStorageWarehouseUnit(
      out.finishedGoodsStorageUnit ?? out.finished_goods_storage_unit,
    );
  }
  if (out.coldStorageUnit != null || out.cold_storage_unit != null) {
    out.coldStorageUnit = resolveColdStorageUnit(out.coldStorageUnit ?? out.cold_storage_unit);
  }
  delete out.raw_material_warehouse_unit;
  delete out.finished_goods_storage_unit;
  delete out.cold_storage_unit;
  return out;
};
